export default __webpack_public_path__ + "static/media/018-pipe.b7ed6db0.png";